import { useGetApiV1CourseregistrationSharedPoloList } from '@/shared/api/generated';

import type { DropdownOption } from './useCompaniesDropdown';

/**
 * Lista de polos para popular filtros de dropdown.
 *
 * @param mainOnly - Se `true`, retorna apenas polos principais.
 */
export function usePolosDropdown(mainOnly = false) {
  const query = useGetApiV1CourseregistrationSharedPoloList({ main: mainOnly });

  const polos: readonly DropdownOption[] = (query.data ?? []).map(item => ({
    id: String(item.key ?? ''),
    name: item.value ?? '',
  }));

  return {
    polos,
    isLoading: query.isLoading,
    isError: query.isError,
  } as const;
}
